$(() => {
  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();
    $('.compare-head.fixedOnScroll').each(function () {
      const topDistance = $(this).offset().top;
      if ((topDistance + 100) < scrollTop) {
        $(this).css('height', $(this).innerHeight());
        $(this).addClass('fixed');
        $('body').addClass('compareFixed');
        $('.catalog-compare-head .fixedOnScroll').fadeIn();
      } else {
        $(this).removeClass('fixed');
        $('body').removeClass('compareFixed');
        $(this).attr('style', '');
      }
    });
  });

  $('.catalog-compare-main').on('scroll', function () {
    $(this).find('.compare-head.fixed .compare-head-holder').css('margin-left', $(this).find('.compare-wrapper').offset().left);
  });

  $('footer').on('inview', (event, isInView) => {
    if (isInView) {
      $('#show-difference-button').addClass('footerInView');
    } else {
      $('#show-difference-button').removeClass('footerInView');
    }
  });

  $('.js-show-compare-diff').on('click', function () {
    $(this).toggleClass('active');
    $('.compare-attributes').each(function () {
      const $sectionWrapper = $(this).closest('.compare-section-wrapper');
      let valEquals = true;
      let lastVal = null;
      $(this).find('.col.item').each(function () {
        const value = $.trim($(this).text());

        if (lastVal !== null && lastVal !== value) {
          valEquals = false;
        }

        lastVal = value;
      });

      if (!valEquals) {
        return;
      }

      $(this).closest('.section-row').toggleClass('hidden');

      if ($sectionWrapper.find('.section-row:not(.hidden)').length > 0) {
        $sectionWrapper.removeClass('hidden');
      } else {
        $sectionWrapper.addClass('hidden');
      }
    });
  });
});
